import { PropTypes } from "../../../wayin-react";
import { withProps, compose, setDisplayName, setPropTypes, defaultProps } from 'react-recompose';
import { removeProps } from "../hoc";
import { sizes, positions } from "../../../enums";
import { PrivateMenu } from "../menu/menu"; // <IconMenu
//   items=[]
//   activeValue={0}
//   size={sizes.X1}
//   float={positions.R}
//   onItemClick={myHandler()}
// />

var IconMenu = compose(setDisplayName('IconMenu'), removeProps(['color', 'menuType', 'borders', 'iconTextDisplay', 'isCompact', 'isPaginated', 'isTextOnly', 'isUnderlined', 'isFluid', 'children']), withProps({
  menuType: 'icon-menu'
}), defaultProps({
  size: sizes.X5
}))(PrivateMenu);
export default IconMenu;
//# sourceMappingURL=index.js.map